// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/woocommerce-products/node_modules/next/dist/esm/next-devtools/userspace/app/segment-explorer-node.js"));
